import TextField from '@mui/material/TextField';
import { useField } from 'formik';

import { textField } from '../../../../types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const TextFieldWrapper = ({ name, ...otherProps }: any) => {
  const [field, mata] = useField(name);
  const configTextField: textField = {
    fullWidth: true,
    variant: 'outlined',
    ...otherProps,
    ...field,
  };
  if (mata?.touched && mata?.error) {
    configTextField.error = true;
    configTextField.helperText = mata.error;
  }
  return (
    <TextField
      {...configTextField}
      style={{ width: '270px', marginBottom: '12px' }}
      data-testid={`test-${name}`}
    />
  );
};

export default TextFieldWrapper;
